"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseContextUrl = void 0;
/* Package Imports */
var query_string_1 = __importDefault(require("query-string"));
/**
 * Utility functions for parsing Faspex urls
 */
// Parses the context from a Faspex url, used for Delivery and Reset Password
var parseContextUrl = function (url) {
    var parsedUrl = query_string_1.default.parseUrl(url);
    var context = parsedUrl.query.context;
    return {
        context: context
    };
};
exports.parseContextUrl = parseContextUrl;
